<!--
  When MSAL renews tokens silently it reloads redirectUri (the app origin) in a hidden
  iframe, which re-boots this whole component. The chrome below (header etc.) fires
  MsalInterceptor-guarded HTTP on init, and acquireTokenRedirect throws inside an iframe
  (BrowserAuthError: redirect_in_iframe / block_iframe_reload — Sentry EMMET-3 / EMMET-9).
  MsalRedirectComponent (<app-redirect> in index.html) handles the auth hash on its own,
  so we render nothing here when framed. See app-routing.module.ts for the matching guard.
-->
@let accountActive = accountActive$ | async;
<ng-container *ngIf="!isIframe">
  <nz-layout class="app">
    <em-header *ngIf="accountActive"></em-header>

    <nz-content>
      <router-outlet></router-outlet>
    </nz-content>

    <nz-footer class="footer"><em-footer></em-footer></nz-footer>
  </nz-layout>

  <ng-container *ngIf="accountActive">
    <em-admin-button></em-admin-button>
    <em-environment-selector></em-environment-selector>
  </ng-container>
</ng-container>
